export default __webpack_public_path__ + "static/media/american_express_logo.e42c838d.jpg";